import {
    Component,
    Input,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { CardsCreator } from '../../services/cards/creator';
import { CommonHttpService } from '../../../shared/services/http.service';
import { Response } from '@angular/http';
import { SubscriptionModel } from '../../../shared/models/subscription.model';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';

@Component({
    selector: 'account-cards-update-subscription',
    templateUrl: './account.cards.update-subscription.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AccountCardsUpdateSubscriptionComponent {
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    @Input() client: ClientModel;
    public card;
    public subscriptions: Array<SubscriptionModel> = [];
    public hasMoreToLoad = true;
    public currentOffset = 0;
    public loading = false;
    public updatedSubscriptions = {};
    protected overlayContext = new OverlayContext();

    constructor(
        protected http: CommonHttpService,
        protected modal: Modal,
        protected cardsCreator: CardsCreator
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;

        this.cardsCreator.created$.subscribe((card) => {
            this.card = card;
            this.indexSubscriptions();
        });
    }

    private indexSubscriptions(offset: number = 0) {
        this.http
        .useAuth()
        .get(
            `account/clients/${this.client.id}/subscriptions`
            + `?_sort=-id`
            + `&_offset=${+offset}`
            + `&_limit=5`
            + `&_fields=id,start_at,status,plan->description`
            + `&_config=meta-has-more-pages`
            + `&_with=plan`
            + `&payment_method->name-lk=*cart*`
        )
        .subscribe((response: Response) => {
            const subscriptions = response.json().data;
            const meta = response.json().meta;

            if (offset === 0) {
                this.subscriptions = [];
            }

            for (let index in subscriptions) {
                if (subscriptions.hasOwnProperty(index)) {
                    this.subscriptions.push(subscriptions[index]);
                }
            }

            this.hasMoreToLoad = meta['meta-has-more-pages'];

            if (offset === 0 && this.subscriptions.length > 0) {
                this.openModal();
            }
        });
    }

    private openModal() {
        this.modal
        .open(this.templateRef, {context: this.overlayContext})
        .then(() => {});
    }

    public closeDialog(dialogRef: any) {
        dialogRef.close();
    }

    public save(dialogRef: any, subscription: SubscriptionModel) {
        this.loading = true;
        this.http.useAuth().put(
            `/account/clients/${this.client.id}/subscriptions/${subscription.id}`,
            {offer_payment_card: {payment_card_id: this.card.id}}
        ).subscribe(() => {
            this.loading = false;
            this.updatedSubscriptions[subscription.id] = true;
        });
    }

    public loadMore() {
        this.currentOffset += 5;
        this.indexSubscriptions(this.currentOffset);
    }

    public wasUpdated(subscription) {
        return this.updatedSubscriptions.hasOwnProperty(subscription.id)
            && !!this.updatedSubscriptions[subscription.id];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/cards/update-subscription/account.cards.update-subscription.component.ts